import _ from 'underscore';
import {
  DisplayDomainColumn,
  StoreDisplayNameColumn,
  ImpressionShareColumn,
  AveragePositionColumn,
  OverlapRateColumn,
  AboveRateColumn,
  TopOfPageRateColumn,
  AbsoluteTopOfPageRateColumn,
  OutrankingShareColumn,
  ImpressionShareWithInsightColumn,
} from '@bingads-webui-campaign/auction-insight-common';
import { ColumnsConfigBuilder } from '@bingads-webui-campaign/summary-grid-helper';
import { uncheckedInjectionContext as globalContext } from '@bingads-webui-campaign/injection-context';
import { CAMPAIGN_TYPES } from '@bingads-webui-campaign/competition-auction-insight-preferences';
import { levelAtConstant } from '@bingads-webui-campaign/scope-constants';

const appConfig = globalContext.require('component/config/index');
const { Columns, SelectedColumns } = globalContext.require('component/bingads-grid/service/column-chooser-preferences');
const i18n = globalContext.require('@bingads-webui/i18n-amd-loader!campaignui/feature/competition-tab');
const permissions = appConfig.get('Permissions');

let builder = null;
let campaignTypeInLastBuilder;

function getBuilder({
  campaignType,
  scope,
}) {
  if (builder === null || campaignTypeInLastBuilder !== campaignType) {
    campaignTypeInLastBuilder = campaignType;

    let performanceColumns;
    let attributesColumns;
    let lockedColumns;
    const isCustomerLevel = _.result(scope, 'levelAt') === levelAtConstant.CUSTOMER;

    if (campaignType === CAMPAIGN_TYPES.Shopping) {
      attributesColumns = [StoreDisplayNameColumn];
      lockedColumns = [
        StoreDisplayNameColumn,
        isCustomerLevel ? ImpressionShareWithInsightColumn : ImpressionShareColumn,
      ];
      performanceColumns = _.compact([
        isCustomerLevel ? ImpressionShareWithInsightColumn : ImpressionShareColumn,
        OverlapRateColumn,
        permissions.IsAvgPositionDeprecationPhase1Enabled && AbsoluteTopOfPageRateColumn,
        OutrankingShareColumn,
      ]);
    } else {
      attributesColumns = [DisplayDomainColumn];
      lockedColumns = [
        DisplayDomainColumn,
        isCustomerLevel ? ImpressionShareWithInsightColumn : ImpressionShareColumn,
      ];
      performanceColumns = _.compact([
        isCustomerLevel ? ImpressionShareWithInsightColumn : ImpressionShareColumn,
        !permissions.IsAvgPositionDeprecationPhase2Enabled && AveragePositionColumn,
        OverlapRateColumn,
        AboveRateColumn,
        TopOfPageRateColumn,
        permissions.IsAvgPositionDeprecationPhase1Enabled && AbsoluteTopOfPageRateColumn,
        OutrankingShareColumn,
      ]);
    }
    const selectedColumns = _.union(attributesColumns, performanceColumns);

    builder = new ColumnsConfigBuilder()
      .addCategory('Attributes', category => category.addColumns(attributesColumns))
      .addCategory('Performance', category => category.addColumns(performanceColumns))
      .setLockedColumns(lockedColumns)
      .setSelectedColumns(selectedColumns);
  }

  return builder;
}

export function getColumnsConfig({
  scope,
  campaignType,
}) {
  return getBuilder({ campaignType, scope }).getColumnsConfig({
    i18n,
    scope,
    campaignType,
  });
}

export function getColumnChooserConfig({ campaignType, scope }) {
  return getBuilder({ campaignType, scope }).getColumnChooserConfig({
    i18n,
    patchQuery: true,
    Columns,
    SelectedColumns,
  });
}
